export default __webpack_public_path__ + "static/media/delete.6a11dbda.svg";